import { gql, useQuery } from '@apollo/client';
import { callSideEffects } from '../../util';
const ESTAB_STATS_QUERY = gql `
    query GetEstabStats($estabIds: [Int!]) {
        getEstabStats(estabIds: $estabIds) {
            estabId
            currentViews
            currentViewsText
            lastBookedDate
            lastBookedDateText
        }
    }
`;
export function useEstabStats(estabStatsRequest, sideEffects, skipQuery = false) {
    const estabIds = (estabStatsRequest === null || estabStatsRequest === void 0 ? void 0 : estabStatsRequest.estabIds) || [];
    const skip = !(estabIds === null || estabIds === void 0 ? void 0 : estabIds.length) || skipQuery;
    return useQuery(ESTAB_STATS_QUERY, {
        notifyOnNetworkStatusChange: true,
        ssr: false,
        variables: {
            estabIds,
        },
        skip,
        onCompleted: (completedData) => {
            if (sideEffects) {
                callSideEffects(sideEffects, completedData);
            }
        },
    });
}
